/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
import React, { useState } from "react";

// library
import styled from "styled-components";

// servicess
import authSvc from "services/authSvc";

// helpers
import { isEmail } from "utils/regexExp";

// component
import Button from "components/Button";
import H1 from "components/H1";
import H4 from "components/H4";
import TextInput from "components/TextInput";
import Toast from "components/Toast";
import FormTitle from "./components/FormTitle";

const Wrapper = styled.div`
  padding: 20px;
  max-width: 650px;
`;

const ForgotPasswordPage = () => {
  const initialValidation = {
    email: { isValid: true, msg: "" },
  };

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState(initialValidation);
  const [toastData, setToastData] = useState({});
  const [toastVisible, setToastVisible] = useState(false);

  const handleForgotPassword = async () => {
    setLoading(true);
    const isValid = validateForm();

    if (!isValid) {
      setLoading(false);
      return;
    }

    const { isSuccess, data } = await requestForgotPassword();
    if (isSuccess) {
      setToastData({ description: data });
      setToastVisible(true);
    }
    setLoading(false);
  };

  const validateForm = () => {
    let validationForm = initialValidation;
    if (!email) {
      validationForm = {
        ...validationForm,
        email: { ...validationForm.email, isValid: false, msg: "Email is required" },
      };
    }
    if (email && !isEmail(email)) {
      validationForm = {
        ...validationForm,
        email: { ...validationForm.email, isValid: false, msg: "Email not valid" },
      };
    }

    setValidation(validationForm);

    let result = true;
    Object.entries(validationForm).forEach(([key, { isValid }]) => {
      if (!isValid) result = false;
    });
    return result;
  };

  const requestForgotPassword = () => {
    return authSvc.forgotPassword({ email }).then(
      (response) => {
        return { isSuccess: true, data: response?.data?.description };
      },
      (err) => {
        return { isSuccess: false, data: err.response?.data?.data[0]?.msg || err.messages };
      }
    );
  };

  return (
    <Wrapper className="row mx-auto justify-content-center align-items-center flex-column">
      <H1 className="margin-bottom-15">Forgot Password</H1>
      <H4 className="margin-bottom-0">
        Enter your email address associated with your account and we’ll send you a link to reset
        your password
      </H4>
      
      <FormTitle
          title=""
          subtitle="Remember your password?"
          link={{ text: "Log in", value: "/auth/login" }}
      />
      <TextInput
        title="Email address"
        value={email}
        placeholder="Enter your email"
        className="margin-bottom-40"
        onChange={(event) => setEmail(event.target.value)}
        invalidFeedback={validation?.email?.msg}
      />
      <Button
        className="w-100"
        loading={loading}
        handleRoute={() => handleForgotPassword()}
        primary
      >
        Sent Reset Instructions
      </Button>
      <Toast
        setIsVisible={(val) => setToastVisible(val)}
        isVisible={toastVisible}
        description={toastData.description}
        undo={toastData.undo}
      />
    </Wrapper>
  );
};

export default ForgotPasswordPage;
